// extracted by mini-css-extract-plugin
module.exports = {"rating-label":"feedback_rating-label__cNdAO","filled-star":"feedback_filled-star__TysDL"};